export const UNACCEPTED_TERMS_AND_CONDITIONS = 'unaccepted_terms_and_conditions'
export const NEW_TERMS_AND_CONDITIONS = 'new_terms_and_conditions'
export const UNACCEPTED_SWORN_STATEMENT = 'unaccepted_sworn_statement'
export const AUTH_USER_NOT_FOUND = 'auth_user_not_found'